export default __webpack_public_path__ + "static/media/kitchen-pack-7.ac9feb0c.png";